import { http } from 'shared/api/http';

export const pilatesSettingsApi = {
  // mevcutlar
  getAll() {
    return http('/api/v1/pilates/settings', { method: 'GET' });
  },

  createPlan(payload) {
    return http('/api/v1/pilates/settings/plans', {
      method: 'POST',
      body: payload,
    });
  },

  updatePlan(id, payload) {
    return http(`/api/v1/pilates/settings/plans/${id}`, {
      method: 'PUT',
      body: payload,
    });
  },

  setPlanActive(id, active) {
    return http(`/api/v1/pilates/settings/plans/${id}/active`, {
      method: 'PUT',
      body: { active },
    });
  },

  // ✅ Company settings (backend ile uyumlu tek base: /api/v1/company-settings)
  getMy() {
    return http('/api/v1/company-settings/me', { method: 'GET' });
  },

  // (opsiyonel) setup endpoint'in varsa
  saveMySetup(payload) {
    return http('/api/v1/company-settings/me/setup', {
      method: 'POST',
      body: payload,
    });
  },

  // ✅ Email notifications
  getMyEmailNotifications() {
    return http('/api/v1/company-settings/me/notifications/email', { method: 'GET' });
  },

  updateMyEmailNotifications(payload) {
    return http('/api/v1/company-settings/me/notifications/email', {
      method: 'PUT',
      body: payload,
    });
  },

  // =========================
  // 🏢 Company Business Rules
  // =========================

  getBusinessRules() {
    return http('/api/v1/pilates/settings/business-rules', {
      method: 'GET',
    });
  },

  updateBusinessRules(rules) {
    return http('/api/v1/pilates/settings/business-rules', {
      method: 'PUT',
      body: { rules }, // BusinessRulesRequest ile uyumlu
    });
  },
};
